import { getData, postData } from 'helpers/apiHelper';
import { MAIN_PATH, GET_DOC_STORAGE_INFO, GET_STORAGE_UPGRADE_PLANS, PURCHASE_STORAGE_UPGRADE_PLAN, STORAGE_UPGRADE_BILLING_PORTAL } from './apiPath';

// Get storage information
export function getStorageInfo() {
  return getData(`${MAIN_PATH}${GET_DOC_STORAGE_INFO}`)
}

// Get upgrade plans list
export function getStorageUprgadePlans() {
  return getData(`${MAIN_PATH}${GET_STORAGE_UPGRADE_PLANS}`)
}

// Purchase plan
export function purchaseStoragePlan(planId) {
  return postData(`${MAIN_PATH}${PURCHASE_STORAGE_UPGRADE_PLAN}/${planId}`)
}

// Get billing portal url

export function getBillingPortalURL() {
  return postData(`${MAIN_PATH}${STORAGE_UPGRADE_BILLING_PORTAL}`)
}